import React from "react";
import CheckInOutPage from "./CheckInOutPage";
import { RouteProps } from "react-router-dom";
import withValidUserRole, { withValidUserRoleProps } from "../Auth/ProtectedPage";

interface CheckInOutPageContainerProps extends RouteProps, withValidUserRoleProps {}

const CheckInOutPageContainer = (props: CheckInOutPageContainerProps) => {
    const getTitle = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "Templates" : `${path.charAt(1).toUpperCase()}${path.slice(2)}`;
    };

    const getType = () => {
        const path = props.location ? props.location.pathname : "";
        return path === "/" ? "templates" : getTitle().toLowerCase();
    };

    return <CheckInOutPage title={getTitle()} category={getType()} />;
};

export default withValidUserRole(CheckInOutPageContainer);
